import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { LayoutRenderer } from '@ignitesales/neuro-application/src/neuro-guide/components/QuestionGroups/layouts';

/**
 * GridBlockRenderer
 * Wrapper around Neuro's LayoutRenderer to render a block (header/footer) configuration.
 *
 * @param {Object} props
 * @param {Object} props.blockConfig The layout configuration for the block
 */
const GridBlockRenderer = ({ blockConfig }) => {
    // LayoutRenderer expects an 'action' object with a 'layoutId' property.
    // It then uses useGuideConfig to look up the layout by that ID.
    // Since blockConfig IS the layout object from useGuideConfig().layouts,
    // we can just pass its ID.
    const action = useMemo(() => ({
        layoutId: blockConfig.id
    }), [blockConfig.id]);

    if (!blockConfig) {
        return null;
    }

    console.log('GridBlockRenderer rendering block:', blockConfig);

    return (
        <div className={`grid-block-renderer grid-block-renderer--${blockConfig.position}`}>
             <LayoutRenderer action={action} layout={blockConfig} />
        </div>
    );
};

GridBlockRenderer.propTypes = {
    blockConfig: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        position: PropTypes.string,
        layoutType: PropTypes.string
    }).isRequired
};

export default GridBlockRenderer;
